interface PlanHeatmapApiModel {
  name: string;
  description: string;
  json_data_string: string;
}

class PlanHeatmap {
  name: string;

  description: string;

  jsonDataString: string;

  constructor(name: string, description: string, jsonDataString: string) {
    this.name = name;
    this.description = description;
    this.jsonDataString = jsonDataString;
  }

  static fromApi(apiObject: PlanHeatmapApiModel) {
    return new PlanHeatmap(apiObject.name, apiObject.description, apiObject.json_data_string);
  }

  toApi(): PlanHeatmapApiModel {
    return {
      name: this.name,
      description: this.description,
      json_data_string: this.jsonDataString,
    };
  }
}

export default PlanHeatmap;
